// extracted by mini-css-extract-plugin
export default {"banner":"agent-banner_banner__QPQgo"};